import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, firstValueFrom, from, lastValueFrom, Observable, throwError } from 'rxjs';
import { AuthService, LOGOUT_PATH } from '@services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly auth = inject(AuthService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return from(this.handleAuth(request, next));
  }

  async handleAuth(request: HttpRequest<unknown>, next: HttpHandler): Promise<HttpEvent<unknown>> {
    const authCredentials = this.auth.qrRouteActive() ? undefined : await firstValueFrom(this.auth.authCredentials$);
    let authReq = request;
    if (authCredentials != null) {
      authReq = request.clone({
        headers: new HttpHeaders({
          Authorization: `Bearer ${authCredentials.token}`,
          'is-dashboard': 'true',
        }),
      });
    }

    return await lastValueFrom(next.handle(authReq).pipe(catchError((error) => {
      // Der Logout-Call ist ausgenommen: er würde sonst über logout() den nächsten
      // Logout-Call auslösen und sich endlos selbst nachladen.
      //
      // Ohne Widerruf: ein 401 hat den Token ohnehin schon verworfen, und ein 403 ist in
      // diesem Backend eine reguläre Antwort der Rechteprüfung - er darf nicht die
      // Sitzungen desselben Benutzers auf anderen Geräten mit abräumen.
      if (authCredentials != null && error instanceof HttpErrorResponse && !request.url.endsWith(LOGOUT_PATH)
        && !this.auth.isQrSessionRequest(request.url)) {
        if (error.status === 401 || error.status === 403) {
          this.auth.logout({ revokeServerSession: false });
        }
      }
      return throwError(() => error);
    })));
  }
}
